export const i18N = () => {
    return acp_woocommerce_i18n.woocommerce;
};
